import { Action } from '@ngrx/store';

export enum TitlesActionTypes {
  TitlesLoaded = '[Titles] Titles Loaded',
  TitlesLoadFiled = '[Titles] Titles Load Failed',
  LoadTitles = '[Titles] Load titles'
}

export class LoadTitles implements Action {
  readonly  type = TitlesActionTypes.LoadTitles;
}

export class TitlesLoaded implements Action {
  readonly type = TitlesActionTypes.TitlesLoaded;

  constructor(public titles:Array<any>) {}
}

export class TitlesLoadFailed implements Action {
  readonly type = TitlesActionTypes.TitlesLoadFiled;

  constructor(public err:any) {}
}

export type TitlesActions = TitlesLoaded | TitlesLoadFailed | LoadTitles;
